import InlineForm from '@plone/volto/components/manage/Form/InlineForm';
import { Icon, SidebarPortal } from '@plone/volto/components';
import documentDetailsSVG from '@plone/volto/icons/doument-details.svg';
import MetadataPostSchema from './schema';
import View from './View';

const Edit = (props) => {
  const schema = MetadataPostSchema(props.intl);
  return (
    <>
      <SidebarPortal selected={props.selected}>
        <InlineForm
          schema={schema}
          title={schema.title}
          icon={<Icon name={documentDetailsSVG} />}
          onChangeField={(id, value) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              [id]: value,
            });
          }}
          formData={props.data}
        />
      </SidebarPortal>
      <View data={props.data} metadata={props.metadata} isEditMode={true} />
    </>
  );
};

export default Edit;
